import HomeScreen from '../../components/home/index'

export default HomeScreen;